<template>
  <div>
    <v-dialog v-model="show">
      <v-card>
        <v-card-title class="d-flex" style="position: relative" :class="$vuetify.breakpoint.smAndDown ? 'justify-start' : 'justify-center'">
            <h2>{{isNew ? 'New Contractor' : 'Edit Contractor ' + contractor.id}}</h2>
          <v-btn icon style="position: absolute; right: 15px; top: 10px;" @click="show=false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text :class="{'pa-0': $vuetify.breakpoint.smAndDown}">
          <v-container container--fluid grid-list-xl pb-0>
            <v-form
              ref="form"
              v-model="valid">
              <v-row>
                <v-expansion-panels :key="1" accordion>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                     <h3>Basic Details</h3>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row justify="space-between" align="center" :class="{'flex-column': $vuetify.breakpoint.smAndDown}">
                        <v-col cols="12" md="3">
                          <v-text-field
                            v-model="contractor.name"
                            label="Name"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="3">
                          <v-text-field
                            v-model="contractor.legal_name"
                            label="Legal Name"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="3">
                          <v-text-field
                            v-model="contractor.abn"
                            label="ABN"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="2">
                          <v-switch
                            v-if="!isNew"
                            class="justify-center"
                            color="blue"
                            v-model="contractor.active"
                            :label="contractor.active ? 'Active' : 'Inactivated'"
                            @change="activateOrDeactivate"
                          ></v-switch>
                        </v-col>
                      </v-row>

                      <v-row justify="space-between" align="center" :class="{'flex-column': $vuetify.breakpoint.smAndDown}">
                        <v-col cols="12" md="3">
                          <v-text-field
                            v-model="contractor.address"
                            label="Address"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="3">
                          <v-text-field
                            v-model="contractor.suburb"
                            label="Suburb"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="3">
                          <v-text-field
                            v-model="contractor.state"
                            label="State"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="2">
                          <v-text-field
                            v-model="contractor.postcode"
                            label="Postcode"
                            required
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row justify="space-between" align="center" :class="{'flex-column': $vuetify.breakpoint.smAndDown}">
                        <v-col cols="12" md="3">
                          <v-text-field
                            v-model="contractor.contact_name"
                            label="Contact Name"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="2">
                          <v-text-field
                            v-model="contractor.contact_phone"
                            label="Contact Phone"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="2">
                          <v-text-field
                            v-model="contractor.contact_email"
                            label="Contact Email"
                            :rules="emailRules"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="2">
                          <v-text-field
                            v-model="contractor.account_email"
                            label="Account Email"
                            :rules="emailRules"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="2">
                          <v-switch
                            class="justify-center"
                            color="blue"
                            v-model="contractor.gst_registered"
                            :label="contractor.gst_registered ? 'GST' : 'No GST'"
                          ></v-switch>
                        </v-col>
                      </v-row>

                      <v-row justify="space-between" align="center" :class="{'flex-column': $vuetify.breakpoint.smAndDown}">
                        <v-col cols="12" md="3">
                          <v-text-field
                            v-model="contractor.oracle_supplier_number"
                            label="Oracle Supplier Number"
                            :rules="[numberRules]"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="3">
                          <v-text-field
                            v-model="contractor.oracle_supplier_name"
                            label="Oracle Supplier Name"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="3"></v-col>
                        <v-col cols="12" md="2"></v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <v-expansion-panel v-if="!isNew">
                    <v-expansion-panel-header>
                      <h3>Costs</h3>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <RouteCostStructureDataTable
                        v-if="!isNew"
                        :region="region"
                        :contractor="contractor"
                      ></RouteCostStructureDataTable>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <v-expansion-panel v-if="!isNew">
                    <v-expansion-panel-header>
                      <h3>Users</h3>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <ContractorUsersDataTable
                        v-if="!isNew"
                        :contractor="contractor"
                        :regionDepots="regionDepots"
                      ></ContractorUsersDataTable>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <v-expansion-panel v-if="!isNew">
                    <v-expansion-panel-header>
                      <h3>Invoices</h3>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <ContractorInvoiceDataTable
                        v-if="!isNew"
                        :contractor="contractor"
                      ></ContractorInvoiceDataTable>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                </v-expansion-panels>
              </v-row>

              <v-row justify="center" align="center" :class="{'flex-column': $vuetify.breakpoint.smAndDown}">
                <v-col cols="12" md="3" class="text-center">
                  <v-btn
                    text
                    @click="$emit('close')"
                    color="blue-grey lighten-2"
                  >Cancel</v-btn>
                </v-col>
                <v-col cols="12" md="3" class="text-center">
                  <v-btn
                    text
                    @click="$emit('save')"
                    color="blue darken-1"
                  >Save</v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import axios from 'axios';
  import ContractorUsersDataTable from './ContractorUsersDataTable';
  import ContractorInvoiceDataTable from './ContractorInvoiceDataTable';
  import RouteCostStructureDataTable from '../../pages/Delivery/Routes/RouteCostStructureDataTable';

    export default {
      name: "EditContractor",
      props: {
        region: Object,
        regionDepots: Array,
        contractor: Object,
        editDialog: Boolean
      },
      components: {
          ContractorUsersDataTable,
          ContractorInvoiceDataTable,
          RouteCostStructureDataTable,
      },
      data() {
        return {
          valid: true,
          loading: false,
          emailRules:[
            v => /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/.test(v)  ||  'Email must be vaild',
          ],
        }
      },
      computed: {
        show: {
          get() {
            return this.editDialog;
          },
          set(value) {
            if (!value) this.$emit('close');
          }
        },
        isNew() {
          return (this.contractor === null || this.contractor.id <= 0);
        }
      },
      methods: {
        validate () {
          if (this.$refs.form.validate()) {
            this.snackbar = true
          }
        },
        reset () {
          this.$refs.form.reset()
        },
        resetValidation () {
          this.$refs.form.resetValidation()
        },
        numberRules(val){
          if(val !== null){
            if (val == ''){
              return true;
            } else if(/^[0-9]*$/.test(val) == false){
              return 'Must be Integer';
            } else {
              return true;
            }
          } else return true;
        },
        activateOrDeactivate() {
          let suffix = '';
          if (this.contractor.active) {
            suffix = '/activate';
          } else {
            suffix = '/deactivate';
          }
          axios.post(process.env.API_URL + '/contractors/' + this.contractor.id + suffix)
              .then((response) => {
                this.$store.commit('displaySnackbar', 'Successfully ' + (this.contractor.active ? 'activated' : 'deactivated') + ' contractor ' + this.contractor.id)
              })
              .catch((error) => {
                if (error.response !== undefined) {
                  this.$store.commit('displaySnackbar', 'ERROR: ' + error.response.data.error);
                } else {
                  this.$store.commit('displaySnackbar','ERROR: activate/deactivate failed');
                }
                this.contractor.active = !this.contractor.active;
              })
        },
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/util/Contractors/EditContractor.vue